import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AbmImagenesComponent } from './components/abm-imagenes/abm-imagenes.component';


const routes: Routes = [
  { path: '', component: AbmImagenesComponent },
  { path: 'abm-imagenes', component: AbmImagenesComponent },
  { path: '**', redirectTo: '/home', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
